// state
const state = {
  purchase_list: [],
  date: null,
  tabs: null,
  total_final: null,
  access_token: null,
  userDetail: [],
  user_data: [],
  data_frozen: [],
  po_lists_id: null,
  supplier_id: null,
  supplier_name: null,
  loop_id: 0,
  type_vat: null,
  token: null,
  status: null,
  lot_number: null,
  lot_number_product_id: null,
  lot_number_product_date: null,
  link_url: '',
  page: 1,
  page_nonSet: 1,
  page_close: 1,
  page_low_cost: 1,
  page_high_cost: 1,
  perPage: 10,
  notify: {
    main: 0,
    expired: 0,
    damaged: 0,
    return: 0,
    reduct: 0,
    bin: 0,
  },
  monthThai: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
  monthList:[
    {
      id:1,
      name:'มกราคม',
      name_en:'January',
    },
    {
      id:2,
      name:'กุมภาพันธ์',
      name_en:'February',
    },
    {
      id:3,
      name:'มีนาคม',
      name_en:'March',
    },
    {
      id:4,
      name:'เมษายน',
      name_en:'April',
    },
    {
      id:5,
      name:'พฤษภาคม',
      name_en:'May',
    },
    {
      id:6,
      name:'มิถุนายน',
      name_en:'June',
    },
    {
      id:7,
      name:'กรกฎาคม',
      name_en:'July',
    },
    {
      id:8,
      name:'สิงหาคม',
      name_en:'August',
    },
    {
      id:9,
      name:'กันยายน',
      name_en:'September',
    },
    {
      id:10,
      name:'ตุลาคม',
      name_en:'October',
    },
    {
      id:11,
      name:'พฤศจิกายน',
      name_en:'November',
    },
    {
      id:12,
      name:'ธันวาคม',
      name_en:'December',
    },
  ],
  invoiceDetail:{},
  socket_list: {},
};
export default state
